import React from "react";
import styled, { css } from "styled-components";
import { Speaker } from "q-components";

export const IconRight = (
  <svg
    width="20"
    height="13"
    viewBox="0 0 20 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.125 12.0632C13.875 11.8105 13.875 11.5579 14.125 11.3053L18.3125 6.63158H0.5C0.166665 6.63158 0 6.46316 0 6.12632C0 5.78947 0.166665 5.62105 0.5 5.62105H18.3125L14.125 0.947369C13.875 0.694736 13.875 0.442107 14.125 0.189475C14.375 -0.0631582 14.625 -0.0631582 14.875 0.189475C18.1667 3.85265 19.8333 5.70526 19.875 5.74737C19.9583 5.83158 20 5.95789 20 6.12632C20 6.29474 19.9583 6.42105 19.875 6.50526L14.875 12.0632C14.7917 12.1474 14.6667 12.1895 14.5 12.1895C14.3333 12.1895 14.2083 12.1474 14.125 12.0632Z"
      fill="currentColor"
    />
  </svg>
);

const IconButton = styled.span`
  background: transparent;
  border: none;
  padding: var(--s-small);
  position: absolute;
  bottom: 0;
  right: 0;
  color: inherit;
  transition: transform var(--t-fast) var(--e-out);
  pointer-events: none;
`;

const StyledBox = styled.button`
  --transparent: transparent;
  --transparent--color: var(--c-white);
  pointer-events: ${(props) => props.noSlug && "none"};

  background: var(--c-white);
  color: var(--c-black);
  padding: var(--s-tiny) var(--s-small) var(--s-small);
  position: relative;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  border-radius: 1px;
  transition: box-shadow var(--t-fast) var(--e-out),
    opacity var(--t-slow) linear;
  background-color: ${(props) => `var(${props.bg})`};
  color: ${(props) => `var(${props.bg}--text)`};
  opacity: ${(props) => (props.canceled ? 0.4 : 1)};
  ${(props) =>
    props.bg === "--transparent" &&
    css`
      border: 1px solid white;
    `}
  &:hover ${IconButton} {
    transform: translateX(5px);
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.2);
  }
  &::-moz-focus-inner {
    border: 0;
  }

  &:disabled {
    cursor: default;
  }

  & + & {
    margin-top: var(--s-tiny);
  }

  h3 {
    margin: var(--s-tiny) 0;
  }

  ${(props) =>
    props.canceled &&
    css`
      &:after {
        content: "";
        position: absolute;
        background-color: var(--c-black);
        color: white;
        font-size: 20px;
        font-family: var(--f-header);
        opacity: 0;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `}

  .box__header {
    display: flex;
    justify-content: space-between;
    min-height: 12px;
  }

  .box__legend {
    color: inherit;
    width: 16px;
    height: 16px;
    /* fill: currentColor; */
  }
`;

const Box = (props) => {
  const {
    talkTitle,
    speakers,
    sidebarOpen,
    restProps,
    active,
    setCurrentTalk,
    setSidebarOpen,
    slug,
    canceled,
    talk,
    location,
    category,
    bgColor,
  } = props;

  // let bg =
  //   location && location.name.includes("Saphir")
  //     ? "--c-white"
  //     : location && location.name.includes("Amethyst")
  //     ? "--c-neutral--600"
  //     : location && location.name.includes("Opal")
  //     ? "--c-neutral--500"
  //     : location && location.name.includes("Jade")
  //     ? "--c-neutral--700"
  //     : location && location.name.includes("Banketten")
  //     ? "--c-white"
  //     : location && location.name.includes("Królewski")
  //     ? "--c-neutral--600"
  //     : "--transparent";
  let bg = talk.acf?.category?.name === "Talk" ? "--c-white" : "--transparent";

  return (
    <StyledBox
      canceled={canceled}
      {...restProps}
      bg={bg}
      type="button"
      noSlug={!slug}
      onClick={() => {
        if (slug) {
          setSidebarOpen(sidebarOpen ? false : slug);
          setCurrentTalk(talk);
          document.title = talkTitle + " - Qday";
          document
            .querySelector('meta[name="description"]')
            .setAttribute("content", talkTitle);
        }
      }}
      active={active}
    >
      <header className="box__header">
        <h5>
          {location.name}
          {category && ` - ${category.name}`}
        </h5>
      </header>
      <h3>{talkTitle}</h3>
      {speakers && (
        <div className="speakers">
          {speakers.map((speaker) => (
            <Speaker
              key={speaker.name}
              name={speaker.name}
              company={speaker.company}
              image={speaker.image}
            />
          ))}
        </div>
      )}
      {slug && <IconButton>{IconRight}</IconButton>}
    </StyledBox>
  );
};

export default Box;
